import styled from 'styled-components';
import type { PopoutProps } from '@elfsight/widget-modal';
import { Popout } from '@elfsight/widget-modal';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useBusinessHoursProps } from '../business-hours-props-context';
import { Schedule } from './schedule';

export function SchedulePopout({
  show,
  anchorElement,
  onCloseRequest,
  ...forwardingProps
}: PopoutProps) {
  const { textColor } = useBusinessHoursProps();

  return (
    <Popout
      closeOnOutsideClick
      onCloseRequest={onCloseRequest}
      show={show}
      anchorElement={anchorElement}
      alignment="left"
      direction="downward"
      offsetTop={4}
      {...forwardingProps}
    >
      <Container onClick={(e) => e.stopPropagation()} _color={textColor}>
        <Schedule insidePopout />
      </Container>
    </Popout>
  );
}

const Container = styled.div<{ _font?: string; _color: string }>`
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: auto;
  overflow: auto;
  background: ${({ _color }) => getInvertedColor(_color)};
  color: ${({ _color = '#212121' }) => _color};
`;
